<div class="correspondant-container">
   <div *ngIf="true"class="correspondants-container">
        <header class="page-header">
          <div class="header-content">
            <div class="title-section">
              <h1 class="page-title">Correspondants Médicaux</h1>
            </div>
            <div class="results-info">
              <span class="results-count">{{ totalItems }} correspondant(s) trouvé(s)</span>
            </div>
            <div style="display: flex; align-items: center; gap: 1rem;">
              <div class="view-toggle">

                <button class="toggle-button" type="button"
                  (click)="openAnnuaireModal()"
                  title="Annuaire LDAP" aria-label="Connexion LDAP">
                  <mat-icon>people</mat-icon>
                </button>

                <button
                  class="toggle-button" type="button"
                  [class.active]="viewMode === 'grid'"
                  (click)="setViewMode('grid')"
                  title="Vue en grille">
                  <mat-icon>grid_view</mat-icon>
                </button>
                <button
                  class="toggle-button" type="button"
                  [class.active]="viewMode === 'table'"
                  (click)="setViewMode('table')"
                  title="Vue en tableau">
                  <mat-icon>table_rows</mat-icon>
                </button>
              </div>
              <button mat-raised-button color="primary" (click)="openAddModal()" type="button">
                <mat-icon >add</mat-icon>
                Ajouter un contact
              </button>
            </div>
          </div>
        </header>

        <div class="filters-section">
          <!-- Barre de recherche -->
          <mat-form-field appearance="outline" class="search-container">
            <mat-label>Rechercher</mat-label>
            <input
              matInput
              type="text"
              placeholder="Nom"
              [(ngModel)]="needle"
              (input)="onNeedleChange()"
            >
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
          <!-- profession -->
          <mat-form-field appearance="outline" class="filter-select">
              <mat-label>Profession</mat-label>
              <mat-select [(ngModel)]="idProfession" (selectionChange)="applyFilters()">
                <mat-option value="">Toutes les professions</mat-option>
                <mat-option *ngFor="let profession of refProfession" [value]="profession.id">
                  {{ profession.libelle }}
                </mat-option>
              </mat-select>
          </mat-form-field>
          <!-- spécialité -->
          <mat-form-field appearance="outline" class="filter-select">
              <mat-label>Spécialité</mat-label>
              <mat-select [(ngModel)]="idSpecialite" (selectionChange)="applyFilters()">
                <mat-option value="">Toutes les spécialités</mat-option>
                <mat-option *ngFor="let specialite of refSpecialite" [value]="specialite.id">{{ specialite.libelle }}</mat-option>
              </mat-select>
          </mat-form-field>
          <!-- effacer filtre -->
          <div class="filter-chips">
             <!-- Bouton "Effacer les filtres" -->
            <button type="button" *ngIf="hasActiveFilters()" mat-button color="warn" (click)="clearFilters()">
              <mat-icon>close</mat-icon>
              Effacer les filtres
            </button>
          </div>
        </div>

        <!-- Grid View -->
        <div *ngIf="viewMode === 'grid'" class="correspondants-grid">
          <div *ngFor="let correspondant of correspondants" cdkDropList
            [cdkDropListData]="correspondant"
            [cdkDropListConnectedTo]="connectedDropLists"
            (cdkDropListEntered)="onDragEntered(correspondant)"
            (cdkDropListExited)="onDragExited(correspondant)"
            (cdkDropListDropped)="onCardDrop($event)"
            class="correspondants-card" id="dropList-{{ correspondant.id }}"
            [ngClass]="{ 'drop-target': dropTarget?.id === correspondant.id }">

            <div cdkDrag [cdkDragData]="correspondant" >
              <!-- Drag preview personnalisé -->
              <ng-template cdkDragPreview>
                <div class="drag-preview-tagCorrespondant">
                    {{ correspondant.titre }} {{ correspondant.prenom }} {{ correspondant.nom }}
                </div>
              </ng-template>

              <div class="card-header">
                <div class="correspondant-info">
                  <h3 class="correspondant-name">
                    {{ correspondant.titre }} {{ correspondant.prenom }} {{ correspondant.nom }}
                  </h3>
                  <span class="correspondant-profession">{{ getSpecialiteLabel(correspondant.idSpecialite) }}</span>
                </div>
                <div class="card-actions">
                  <button type="button" class="action-button edit-button" (click)="editCorrespondant(correspondant)" title="Modifier">
                    <mat-icon color="primary">edit</mat-icon>
                  </button>
                  <button type="button" class="action-button delete-button" (click)="deleteCorrespondant(correspondant)" title="Supprimer">
                    <mat-icon color="warn">delete</mat-icon>
                  </button>
                </div>
              </div>
              <div class="card-content">
                <div class="address-section">
                  <div class="info-item">
                    <mat-icon>location_on</mat-icon>
                    <div class="address-text">
                      <div>{{ correspondant.adresse1 }}</div>
                      <div *ngIf="correspondant.adresse2">{{ correspondant.adresse2 }}</div>
                      <div>{{ correspondant.codePostal }} {{ correspondant.ville }}</div>
                    </div>
                  </div>
                </div>

                <div class="contact-section">
                  <div class="info-item" *ngIf="correspondant.telephone1">
                    <mat-icon>phone</mat-icon>
                    <span>{{ correspondant.telephone1 }}</span>
                  </div>

                  <div class="info-item" *ngIf="correspondant.portable1">
                    <mat-icon>smartphone</mat-icon>
                    <span>{{ correspondant.portable1 }}</span>
                  </div>
                </div>

                <div class="emails-section">
                  <div class="email-item" *ngIf="correspondant.email1">
                    <div class="email-icon email-classic">
                      <mat-icon>mail</mat-icon>
                    </div>
                    <span class="email-text">{{ correspondant.email1 }}</span>
                  </div>

                  <div class="email-item" *ngIf="correspondant.email2">
                    <div class="email-icon email-mssante">
                      <strong >MS</strong>
                    </div>
                    <span class="email-text">{{ getFavoriteMSSanteEmail(correspondant.email2) }}</span>
                    <span class="email-label">MSSanté</span>
                  </div>

                  <div class="email-item" *ngIf="correspondant.adresseApiCrypt">
                    <div class="email-icon email-apicrypt">
                      <mat-icon>lock</mat-icon>
                    </div>
                    <span class="email-text">{{ correspondant.adresseApiCrypt }}</span>
                    <span class="email-label">Apicrypt</span>
                  </div>
                </div>

                <div class="additional-info" *ngIf="correspondant.infos">
                  <p class="info-text">{{ correspondant.infos }}</p>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- Table View -->
        <div *ngIf="viewMode === 'table'" class="correspondants-table mat-elevation-z2">
          <table mat-table [dataSource]="correspondants" class="mat-table" multiTemplateDataRows>

            <!-- Nom -->
            <ng-container matColumnDef="nom">
              <th mat-header-cell *matHeaderCellDef> Nom </th>
              <td mat-cell *matCellDef="let c">
                {{ c.titre }} {{ c.prenom }} {{ c.nom }}
              </td>
            </ng-container>

            <!-- Profession -->
            <ng-container matColumnDef="profession">
              <th mat-header-cell *matHeaderCellDef> Profession </th>
              <td mat-cell *matCellDef="let c">
                <div class="table-contact-item" *ngIf="c.idProfession">{{ getProfessionLabel(c.idProfession) }}</div>
                <div class="table-contact-item" *ngIf="c.idSpecialite">{{ getSpecialiteLabel(c.idSpecialite) }}</div>
              </td>
            </ng-container>

            <!-- Adresse -->
            <ng-container matColumnDef="adresse">
              <th mat-header-cell *matHeaderCellDef> Adresse </th>
              <td mat-cell *matCellDef="let c">
                <div class="table-contact-item">{{ c.adresse1 }}</div>
                <div class="table-contact-item" *ngIf="c.adresse2">{{ c.adresse2 }}</div>
                <div class="table-contact-item">{{ c.codePostal }} {{ c.ville }}</div>
              </td>
            </ng-container>

            <!-- Telephone -->
            <ng-container matColumnDef="telephone">
              <th mat-header-cell *matHeaderCellDef> Téléphone</th>
               <td mat-cell *matCellDef="let c">
                <div class="table-contact-item" *ngIf="c.telephone1">{{ c.telephone1 }}</div>
                <div class="table-contact-item" *ngIf="c.telephone2">{{ c.telephone2 }}</div>
              </td>
            </ng-container>
            <!-- Mobile -->
            <ng-container matColumnDef="mobile">
              <th mat-header-cell *matHeaderCellDef> Mobile </th>
               <td mat-cell *matCellDef="let c">
                <div class="table-contact-item" *ngIf="c.portable1">{{ c.portable1 }}</div>
                <div class="table-contact-item" *ngIf="c.portable2">{{ c.portable2 }}</div>
              </td>
            </ng-container>
            <!-- Autre -->
            <ng-container matColumnDef="autre">
              <th mat-header-cell *matHeaderCellDef> Autre </th>
               <td mat-cell *matCellDef="let c">
                <div class="table-contact-item" *ngIf="c.telephonePerso">{{ c.telephonePerso }}</div>
                <div class="table-contact-item" *ngIf="c.fax">{{ c.fax }}</div>
              </td>
            </ng-container>

            <!-- Emails -->
            <ng-container matColumnDef="emails">
              <th mat-header-cell *matHeaderCellDef> Emails </th>
              <td mat-cell *matCellDef="let c">
                <div class="table-email-item" *ngIf="c.email1">
                  <mat-icon class="email-classic" inline>email</mat-icon> {{ c.email1 }}
                </div>
                <div class="table-email-item" *ngIf="c.email2">
                  <mat-icon class="email-mssante" inline>email</mat-icon> {{ getFavoriteMSSanteEmail(c.email2) }}
                </div>
                <div class="table-email-item" *ngIf="c.adresseApiCrypt">
                  <mat-icon class="email-apicrypt" inline>lock</mat-icon> {{ c.adresseApiCrypt }}
                </div>
              </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let c">
                <button mat-icon-button type="button" color="primary" (click)="editCorrespondant(c)" matTooltip="Modifier">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button type="button" color="warn" (click)="deleteCorrespondant(c)" matTooltip="Supprimer">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- En-tête et lignes -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

        </div>

        <!-- Pagination -->
        <mat-paginator [length]="totalItems" [pageSize]="filtre.perpage" [pageIndex]="filtre.currentPage - 1"
               [hidePageSize]="true" [showFirstLastButtons]="true" (page)="onPageChange($event)">
        </mat-paginator>

        <!-- Modal for Add/Edit -->
        <div class="modal-overlay" *ngIf="showModal">
          <div class="modal-content" (click)="$event.stopPropagation()">
            <ng-container *ngIf="fusionChamps.length > 0">
              <ng-container *ngTemplateOutlet="mergeTemplate"></ng-container>
            </ng-container>
            <ng-container *ngIf="fusionChamps.length === 0">
              <ng-container *ngTemplateOutlet="addEditTemplate"></ng-container>
            </ng-container>
          </div>
        </div>
   </div>
</div>

<!-- ========================== -->
<!-- TEMPLATE: AJOUT / EDITION  -->
<!-- ========================== -->
<ng-template #addEditTemplate>
  <!-- Contenu du formulaire d'ajout / édition ici -->
            <div class="modal-header">
              <h2>{{ isEditing ? 'Modifier' : 'Ajouter' }} un correspondant</h2>
              <button type="button" class="close-button" (click)="closeModal()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="modal-body-scrollable">
              <form class="modal-form" #formRef="ngForm" >
                <!-- Nom et Prénom -->
                <div class="form-row">
                  <div class="form-group">
                    <label>Titre</label>
                    <input type="text" [(ngModel)]="currentCorrespondant.titre" name="titre">
                  </div>
                  <div class="form-group">
                    <label [ngClass]="{ 'ldap-label': currentCorrespondant?.isNomFromAnn}" >Nom * <span *ngIf="currentCorrespondant.isNomFromAnn" class="ldap-badge">Ann</span></label>
                    <input type="text" [(ngModel)]="currentCorrespondant.nom" name="nom" required
                    [ngClass]="{ 'ldap-field': currentCorrespondant?.isNomFromAnn}">
                  </div>
                  <div class="form-group">
                    <label [ngClass]="{ 'ldap-label': currentCorrespondant?.isPrenomFromAnn}">Prénom * <span *ngIf="currentCorrespondant.isPrenomFromAnn" class="ldap-badge">Ann</span></label>
                    <input type="text" [(ngModel)]="currentCorrespondant.prenom" name="prenom" required
                    [ngClass]="{ 'ldap-field': currentCorrespondant?.isPrenomFromAnn}">
                  </div>
                </div>
                <!-- Titre, professions, specialite -->
                <div class="form-row">
                  <div class="form-group">
                    <label [ngClass]="{ 'ldap-label': currentCorrespondant?.isProfessionFromAnn}">Profession <span *ngIf="currentCorrespondant.isProfessionFromAnn" class="ldap-badge">Ann</span></label>
                    <select [(ngModel)]="currentCorrespondant.idProfession" name="profession"
                    [ngClass]="{ 'ldap-field': currentCorrespondant?.isProfessionFromAnn}">
                      <option value="">Sélectionner</option>
                      <option *ngFor="let profession of refProfession" [value]="profession.id">{{ profession.libelle }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label [ngClass]="{ 'ldap-label': currentCorrespondant?.isSpecialiteFromAnn}">Spécialité <span *ngIf="currentCorrespondant.isSpecialiteFromAnn" class="ldap-badge">Ann</span></label>
                    <select [(ngModel)]="currentCorrespondant.idSpecialite" name="specialite"
                    [ngClass]="{ 'ldap-field': currentCorrespondant?.isSpecialiteFromAnn}">
                      <option value="">Sélectionner</option>
                      <option *ngFor="let specialite of refSpecialite" [value]="specialite.id">{{ specialite.libelle }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label [ngClass]="{ 'ldap-label': currentCorrespondant?.isCategorieFromAnn}">Catégorie <span *ngIf="currentCorrespondant.isCategorieFromAnn" class="ldap-badge">Ann</span></label>
                    <select [(ngModel)]="currentCorrespondant.categorie" name="categorie"
                    [ngClass]="{ 'ldap-field': currentCorrespondant?.isCategorieFromAnn}">
                      <option value="">Sélectionner</option>
                      <option *ngFor="let categorie of refCategorie" [value]="categorie.id">{{ categorie.libelle }}</option>
                    </select>
                  </div>
                </div>

                <!-- RPPS -->
                <div class="form-row">
                  <div class="form-group">
                    <label [ngClass]="{ 'ldap-label': currentCorrespondant?.isRppsFromAnn}">RPPS <span *ngIf="currentCorrespondant.isRppsFromAnn" class="ldap-badge">Ann</span></label>
                    <input type="text" [(ngModel)]="currentCorrespondant.rpps" name="rpps"
                    [ngClass]="{ 'ldap-field': currentCorrespondant?.isRppsFromAnn}">
                  </div>
                  <div class="form-group">
                    <button mat-raised-button
                      type="button"
                      class="standard-button"
                      (click)="findInfoByRpps()" [disabled]="!currentCorrespondant.rpps">
                      <mat-icon>search</mat-icon>
                      Rechercher dans l'Annuaire de Santé
                    </button>
                  </div>
                </div>

                <!-- Adresse -->
                <div class="form-group">
                  <label>Adresse</label>
                  <input type="text" [(ngModel)]="currentCorrespondant.adresse1" name="adresse1" placeholder="Adresse principale">
                  <input type="text" [(ngModel)]="currentCorrespondant.adresse2" name="adresse2" placeholder="Complément d'adresse">
                  <input type="text" [(ngModel)]="currentCorrespondant.adresse3" name="adresse3" placeholder="Complément d'adresse">
                </div>

                <!-- Code postal et Ville -->
                <div class="form-row">
                  <div class="form-group">
                    <label>Code postal</label>
                    <input type="text" [(ngModel)]="currentCorrespondant.codePostal" name="codePostal">
                  </div>
                  <div class="form-group">
                    <label>Ville</label>
                    <input type="text" [(ngModel)]="currentCorrespondant.ville" name="ville">
                  </div>
                </div>

                <!-- Téléphones -->
                <div class="form-row">
                  <div class="form-group">
                    <label>Téléphone</label>
                    <input type="tel" [(ngModel)]="currentCorrespondant.telephone1" name="telephone1">
                  </div>
                  <div class="form-group">
                    <label>Mobile</label>
                    <input type="tel" [(ngModel)]="currentCorrespondant.portable1" name="portable1">
                  </div>
                  <div class="form-group">
                    <label>Téléphone perso</label>
                    <input type="tel" [(ngModel)]="currentCorrespondant.telephonePerso" name="telephonePerso">
                  </div>
                </div>
                <div class="form-row">
                   <div class="form-group">
                    <label>Téléphone 2</label>
                    <input type="tel" [(ngModel)]="currentCorrespondant.telephone2" name="telephone2">
                  </div>
                  <div class="form-group">
                    <label>Mobile 2</label>
                    <input type="tel" [(ngModel)]="currentCorrespondant.portable2" name="portable2">
                  </div>
                  <div class="form-group">
                    <label>Fax</label>
                    <input type="tel" [(ngModel)]="currentCorrespondant.fax" name="fax">
                  </div>
                </div>
                <!-- emails classique -->
                <div class="form-group">
                  <label>Email non sécurisé</label>
                  <input type="email" [(ngModel)]="currentCorrespondant.email1" name="email1">
                </div>
                <!-- emails Apicrypt -->
                <div class="form-row">
                  <!-- <div class="form-group">
                    <label>Nom Apicrypt</label>
                    <input type="text" [(ngModel)]="currentCorrespondant.nomApiCrypt" name="nomApiCrypt">
                  </div> -->
                  <div class="form-group">
                    <label>Adresse Apicrypt</label>
                    <input type="email" [(ngModel)]="currentCorrespondant.adresseApiCrypt" name="adresseApiCrypt">
                  </div>
                </div>

                <!-- emails MSSanté -->
                <div class="form-group">
                  <label [ngClass]="{ 'ldap-label': currentCorrespondant?.isAdresseMssFromAnn}">Emails MSSanté <span *ngIf="currentCorrespondant.isAdresseMssFromAnn" class="ldap-badge">Ann</span></label>
                  <div class="mssante-emails-manager">
                    <div *ngFor="let email of mssanteEmailsList; let i = index" class="mssante-email-row">
                      <input [ngClass]="{ 'ldap-field': currentCorrespondant?.isAdresseMssFromAnn}" type="email" [(ngModel)]="mssanteEmailsList[i].email"
                        [name]="'mssante_' + i" placeholder="adresse@mssante.fr" class="mssante-email-input">
                      <button class="favorite-toggle-button"  mat-icon-button color="disabled"
                          type="button" (click)="toggleModalMSSanteFavorite(i)"
                          [class.is-favorite]="mssanteEmailsList[i].favori">
                          <mat-icon>
                            {{ mssanteEmailsList[i].favori ? 'star' : 'star_border' }}
                          </mat-icon>
                      </button>
                      <button class="remove-email-button" mat-icon-button color="warn"
                        type="button" (click)="removeMSSanteEmail(i)"
                        [disabled]="mssanteEmailsList.length <= 1" matTooltip="Supprimer cette adresse">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                    <button mat-raised-button
                      type="button"
                      class="add-email-button"
                      (click)="addMSSanteEmail()">
                      <mat-icon>add</mat-icon>
                      Ajouter une adresse MSSanté
                    </button>
                  </div>
                </div>
                <!-- Infos divers -->
                <div class="form-group">
                  <label>Informations complémentaires</label>
                  <textarea [(ngModel)]="currentCorrespondant.infos" name="infos" rows="3"></textarea>
                </div>
              </form>
            </div>
            <div class="modal-actions">
                <button mat-stroked-button type="button" class="cancel-button" (click)="closeModal()">Annuler</button>
                <button mat-stroked-button type="button" class="save-button" (click)="saveCorrespondant(currentCorrespondant)">{{ isEditing ? 'Modifier' : 'Ajouter' }}</button>
            </div>
    <!-- Bottom Sheet de sélection d'adresse MSSanté -->
  <div *ngIf="multipleResults" class="bottom-sheet-overlay" (click)="multipleResults = false"></div>

  <div *ngIf="multipleResults" class="bottom-sheet">
    <h3>Choisissez une adresse MSSanté</h3>
    <br/>
    <div class="bottom-sheet-options">
      <button *ngFor="let r of annuaireResult" (click)="onSelectLdapGroupedResult(r)">
        <span>Profession : {{ r.profession }}<br/></span>
        <span>Adresse : {{ r.address }}, {{ r.zip }} {{ r.city }}<br/></span>
        <strong *ngFor="let mail of r.msSanteAddresses">{{ mail }}<br/></strong>
      </button>
    </div>
  </div>
</ng-template>

<!-- ========================== -->
<!--     TEMPLATE: FUSION       -->
<!-- ========================== -->
<ng-template #mergeTemplate>
  <!-- Contenu du formulaire de fusion ici -->
  <div class="modal-header">
    <h2>Fusion des correspondants</h2>
    <button type="button" class="close-button" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body-scrollable">
    <mat-accordion class="fusion-info-accordion" multi>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>info</mat-icon>
              Conseils avant fusion
          </mat-panel-title>
          <mat-panel-description>
            Cliquez pour afficher ou masquer les recommandations
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ul class="fusion-tips-list">
          <li>- Vous pouvez <strong>fusionner</strong> les champs de la fiche source avec ceux de la fiche à fusionner.</li>
          <li>- Les <strong>champs cochés</strong> seront remplacés par ceux de la source.</li>
          <li>- Si un champ est vide dans la source, <strong>il ne sera pas utilisé</strong>.</li>
          <li>- Les champs venant de l'Annuaire de Santé contenu dans la fiche cible ne seront pas remplacés.</li>
          <li>- Les champs <span class="grayed">grisés</span> indiquent qu'ils seront remplacés par la source.</li>
          <li>- Les champs non cochés seront <strong>conservés</strong> dans la fiche cible.</li>
          <li>- Vous pouvez décocher un champ si vous souhaitez <strong>préserver la donnée existante</strong>.</li>
          <li>- <strong style="color: red;">La fusion est irréversible</strong>, vérifiez bien avant de valider.</li>
          <li>- Les informations de la fiche source seront <strong>définitivement supprimées</strong>.</li>
          <li>- En cas de doute, contactez le support.</li>
        </ul>
      </mat-expansion-panel>
    </mat-accordion>
    <table class="fusion-table">
      <thead>
        <tr>
          <th>Champ</th>
          <th>Fiche source</th>
          <th>Fiche cible</th>
          <th>depuis la source</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let champ of fusionChampsVisibles">
            <td class="champ-label">{{ champ.label }}</td>
            <td class="source-cell">{{ champ.source }}</td>
            <td class="target-cell" [class.grayed]="champ.useSource">{{ champ.target }}</td>
            <td class="select-cell">
              <mat-slide-toggle [(ngModel)]="champ.useSource" color="primary"></mat-slide-toggle>
            </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-actions">
    <button mat-stroked-button type="button" class="cancel-button" (click)="closeModal()">Annuler</button>
    <button mat-stroked-button type="button" class="save-button" (click)="lancerSnackFusion()">Valider</button>
  </div>
</ng-template>

<!-- ========================== -->
<!--  TEMPLATE: SNACK TEMPO     -->
<!-- ========================== -->
<ng-template #fusionSnackTemplate>
  <div class="snack-tempo-container">
    <mat-icon class="snack-icon" color="primary">check_circle</mat-icon>
    <span class="snack-message">Fusion en cours</span>
    <!-- <div class="runner-container">
      <div class="track">
        <div class="runner"></div>
      </div>
    </div> -->
    <span class="snack-actions">
      <button mat-stroked-button color="primary" (click)="snackRef.dismiss()">Annuler</button>
      <button mat-icon-button (click)="snackRef.dismissWithAction()">
        <mat-icon>close</mat-icon>
      </button>
    </span>

  </div>

  <mat-progress-bar mode="determinate" [value]="snackProgressValue" class="snack-progress-bar"></mat-progress-bar>
</ng-template>
